<template>
  <el-footer class="global-footer">
    <div class="footer-content">
      <!-- 四列布局容器 -->
      <div class="footer-columns">
        <!-- 产品列 -->
        <div class="footer-column">
          <h3>{{ t('footerProducts') }}</h3>
          <ul>
            <li><a href="#">{{ t('electricMotorcycles') }}</a></li>
            <li><a href="#">{{ t('motorcycleParts') }}</a></li>
            <li><a href="#">{{ t('batteryExchange') }}</a></li>
            <li><a href="#">{{ t('evChargers') }}</a></li>
            <li><a href="#">{{ t('evCables') }}</a></li>
            <li><a href="#">{{ t('evAdapters') }}</a></li>
          </ul>
        </div>
        
        <!-- 商业解决方案列 -->
        <div class="footer-column">
          <h3>{{ t('footerCommercialSolutions') }}</h3>
          <ul>
            <li><a href="#">{{ t('homeChargingSolutions') }}</a></li>
            <li><a href="#">{{ t('evCharging') }}</a></li>
            <li><a href="#">{{ t('commercialChargingSolutions') }}</a></li>
            <li><a href="#">{{ t('engineeringProjects') }}</a></li>
            <li><a href="#">{{ t('latestNews') }}</a></li>
          </ul>
        </div>
        
        <!-- 快速链接列 -->
        <div class="footer-column">
          <h3>{{ t('footerQuickLinks') }}</h3>
          <ul>
            <li><a href="#">{{ t('blog') }}</a></li>
            <li><a href="#">{{ t('videos') }}</a></li>
            <li><a href="#">{{ t('aboutUs') }}</a></li>
          </ul>
        </div>
        
        <!-- 订阅列 -->
        <div class="footer-column">
          <h3>{{ t('footerSubscribe') }}</h3>
          <p>{{ t('subscribeDescription') }}</p>
          <div class="subscribe-form">
            <input type="email" :placeholder="t('yourEmail')" />
            <button type="submit">{{ t('subscribeButton') }}</button>
          </div>
          <div class="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61577205355724" target="_blank" :title="t('facebook')">
              <span class="icon-facebook">f</span>
            </a>
            <a href="https://www.instagram.com/dr_moto_ev_hk_ltd/" target="_blank" :title="t('instagram')">
              <span class="icon-instagram">in</span>
            </a>
            <a href="whatsapp://send?phone=+85266860815" target="_blank" :title="t('whatsapp')">
              <span class="icon-whatsapp">w</span>
            </a>
            <a href="#" target="_blank" :title="t('tiktok')">
              <span class="icon-tiktok">t</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<style scoped>
/* 全局页脚样式 */
.global-footer {
  background-color: #000;
  color: #fff;
  padding: 40px 0;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  box-sizing: border-box;
}

/* 页脚内容容器 */
.footer-content {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 四列布局容器 */
.footer-columns {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}

/* 列样式 */
.footer-column {
  flex: 1;
  min-width: 200px;
}

.footer-column h3 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column li {
  margin-bottom: 12px;
}

.footer-column a {
  color: #aaa;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.footer-column a:hover {
  color: #fff;
}

/* 订阅表单样式 */
.footer-column p {
  color: #aaa;
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.subscribe-form {
  display: flex;
  margin-bottom: 20px;
}

.subscribe-form input {
  background-color: #1a1a1a;
  border: 1px solid #333;
  color: #fff;
  padding: 10px 15px;
  font-size: 14px;
  width: 100%;
  max-width: 200px;
  outline: none;
  transition: border-color 0.3s ease;
}

.subscribe-form input:focus {
  border-color: #555;
}

.subscribe-form button {
  background-color: #0066cc;
  color: #fff;
  border: none;
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.subscribe-form button:hover {
  background-color: #0052a3;
}

/* 社交媒体图标样式 */
.social-icons {
  display: flex;
  gap: 10px;
}

.social-icons a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background-color: #1a1a1a;
  color: #fff;
  border-radius: 50%;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.social-icons a:hover {
  background-color: #0066cc;
  color: #fff;
}

/* 响应式设计 - 平板端 */
@media (max-width: 1024px) {
  .footer-columns {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .footer-column {
    width: 45%;
    min-width: auto;
  }
}

/* 响应式设计 - 手机端 */
@media (max-width: 768px) {
  .global-footer {
    padding: 30px 0;
  }
  
  .footer-columns {
    flex-direction: column;
    gap: 25px;
  }
  
  .footer-column {
    width: 100%;
  }
  
  .footer-column h3 {
    font-size: 16px;
    margin-bottom: 15px;
  }
  
  .footer-column a {
    font-size: 13px;
  }
  
  .subscribe-form {
    flex-direction: column;
    gap: 10px;
  }
  
  .subscribe-form input {
    max-width: none;
  }
  
  .subscribe-form button {
    width: 100%;
  }
}

/* 响应式设计 - 超小屏幕 */
@media (max-width: 480px) {
  .footer-content {
    padding: 0 15px;
  }
  
  .footer-column {
    margin-bottom: 20px;
  }
  
  .footer-column:last-child {
    margin-bottom: 0;
  }
}
</style>
